var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(-733 -6160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    transform: "translate(733 6160)",
    fill: "rgba(193,193,193,0.14)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 50.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic-facebook",
    d: "M1045.359,6013.527v-21.583h-5.708v-7.774h5.708v-6.64c0-5.213,3.371-10,11.14-10a47.445,47.445,0,0,1,5.472.3l-.184,7.259s-2.371-.023-4.96-.023c-2.8,0-3.25,1.289-3.25,3.434v5.675h8.434l-.367,7.774h-8.067v21.583Z",
    transform: "translate(-267.181 221.474)",
    fill: "#9f9f9f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.e6c11d9a71222ab05f33b20b7e69de84.svg";
export { ForwardRef as ReactComponent };